import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

const detail = (err, fb) => { const d = err?.response?.data?.detail; return typeof d === "string" ? d : fb; };

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(detail(err, "Could not send reset link")); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5" data-testid="forgot-password-page">
      <div className="w-full max-w-md card-ive p-8">
        <div className="type-label text-[#C8102E] mb-3">Ironveil Era</div>
        <h1 className="font-display text-2xl mb-3">Forgot password</h1>
        {sent ? (
          <div data-testid="forgot-sent">
            <p className="text-[#c9c9c9]">If an admin account exists for <span className="text-white">{email}</span>, a reset link is on its way. It is valid for 1 hour.</p>
            <Link to="/admin/login" className="btn-text mt-6 inline-flex" data-testid="back-to-login">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p className="text-[#a0a0a0] text-sm mb-6">Enter your admin email and we will send you a link to set a new password.</p>
            <label className="block mb-6">
              <div className="type-meta text-[#888] mb-2">Email</div>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3" data-testid="forgot-email" />
            </label>
            <button disabled={loading} className="btn-primary w-full" data-testid="forgot-submit">{loading ? "Sending…" : "Send reset link"}</button>
            <div className="mt-5 text-center"><Link to="/admin/login" className="btn-text text-[#a0a0a0]">Back to sign in</Link></div>
          </form>
        )}
      </div>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState(""); const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try { await api.post("/auth/reset-password", { token, new_password: pw }); toast.success("Password updated — sign in with your new password"); nav("/admin/login"); }
    catch (err) { toast.error(detail(err, "Reset failed")); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5" data-testid="reset-password-page">
      <form onSubmit={submit} className="w-full max-w-md card-ive p-8">
        <div className="type-label text-[#C8102E] mb-3">Ironveil Era</div>
        <h1 className="font-display text-2xl mb-6">Set a new password</h1>
        {!token && <p className="text-[#C8102E] text-sm mb-4" data-testid="reset-missing-token">This link is missing its token. Request a new one from the forgot-password page.</p>}
        <label className="block mb-4">
          <div className="type-meta text-[#888] mb-2">New password (min 8 characters)</div>
          <input type="password" required minLength={8} autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full px-4 py-3" data-testid="reset-password" />
        </label>
        <label className="block mb-6">
          <div className="type-meta text-[#888] mb-2">Confirm new password</div>
          <input type="password" required autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full px-4 py-3" data-testid="reset-confirm" />
        </label>
        <button disabled={loading || !token} className="btn-primary w-full" data-testid="reset-submit">{loading ? "Updating…" : "Update password"}</button>
        <div className="mt-5 text-center"><Link to="/admin/forgot-password" className="btn-text text-[#a0a0a0]">Request a new link</Link></div>
      </form>
    </div>
  );
}
